import React from 'react';
import PropTypes from 'prop-types';

import ReservationNormalTheme from './reservation_normal_theme';
import ReservationThirdTheme from './reservation_third_theme';

import { CALENDAR_THEMES } from '../../constants';

import './reservation.scss';

const Reservation = props => {
  const { theme } = props;

  if (theme === CALENDAR_THEMES.THIRD) {
    return <ReservationThirdTheme {...props} />;
  }

  return <ReservationNormalTheme {...props} />;
};

Reservation.propTypes = {
  cellWidth: PropTypes.number,
  checkin: PropTypes.shape({}),
  checkinHightlighted: PropTypes.bool,
  checkout: PropTypes.shape({}),
  checkoutHightlighted: PropTypes.bool,
  containerClassName: PropTypes.string,
  empty: PropTypes.bool,
  expanded: PropTypes.bool,
  firstDataInRow: PropTypes.bool,
  grayedOut: PropTypes.bool,
  mode: PropTypes.string,
  nextReservationDate: PropTypes.string,
  nextReservationReadyStatus: PropTypes.any,
  numberOfOccupied: PropTypes.number,
  occupied: PropTypes.shape({}),
  occupiedHightlighted: PropTypes.bool,
  reservationTextDuration: PropTypes.shape({}),
  theme: PropTypes.string,
};

export default Reservation;
